import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import '@/styles/application.css'

const el = document.getElementById('app')

if (el) {
  createRoot(el).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

